<template>
  <div v-if="statistics">
    <CCard>
      <CCardHeader>
        <div class="d-flex justify-content-between align-items-center">
          <strong>Статистика A/B теста: {{ statistics.test.name }}</strong>
          <CBadge :color="statistics.test.active ? 'success' : 'secondary'">
            {{ statistics.test.active ? 'Активен' : 'Неактивен' }}
          </CBadge>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow class="mb-4">
          <CCol md="3">
            <div class="text-center">
              <h4>{{ totalAssignments }}</h4>
              <p class="text-muted">Всего участников</p>
            </div>
          </CCol>
          <CCol md="3">
            <div class="text-center">
              <h4>{{ totalConversions }}</h4>
              <p class="text-muted">Всего конверсий</p>
            </div>
          </CCol>
          <CCol md="3">
            <div class="text-center">
              <h4>{{ overallConversionRate }}%</h4>
              <p class="text-muted">Общий CR</p>
            </div>
          </CCol>
          <CCol md="3">
            <div class="text-center">
              <h4>{{ statistics.test.traffic_allocation }}%</h4>
              <p class="text-muted">Трафик теста</p>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>
        <strong>Результаты по вариантам</strong>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          :items="statistics.statistics"
          :fields="statisticsFields"
          hover
          striped
        >
          <template #variant="{ item }">
            <td>
              <div>
                <strong>{{ item.variant.name }}</strong>
                <br>
                <small class="text-muted">{{ item.variant.key }}</small>
              </div>
            </td>
          </template>
          
          <template #weight="{ item }">
            <td>{{ item.variant.weight }}%</td>
          </template>
          
          <template #assignments="{ item }">
            <td>
              <span class="h5">{{ item.assignments }}</span>
              <div class="progress mt-1" style="height: 4px;">
                <div 
                  class="progress-bar" 
                  :style="{ width: assignmentPercentage(item.assignments) + '%' }"
                ></div>
              </div>
            </td>
          </template>
          
          <template #conversions="{ item }">
            <td>
              <span class="h5">{{ item.conversions }}</span>
              <div class="progress mt-1" style="height: 4px;">
                <div 
                  class="progress-bar bg-success" 
                  :style="{ width: conversionPercentage(item.conversions) + '%' }"
                ></div>
              </div>
            </td>
          </template>
          
          <template #conversionRate="{ item }">
            <td>
              <span class="h5" :class="conversionRateColor(item.conversionRate)">
                {{ item.conversionRate }}%
              </span>
              <div class="progress mt-1" style="height: 4px;">
                <div 
                  class="progress-bar bg-info" 
                  :style="{ width: item.conversionRate + '%' }"
                ></div>
              </div>
            </td>
          </template>
        </CDataTable>
        
        <div class="alert alert-info mt-3" v-if="statistics.statistics.length > 1">
          <strong>Лучший вариант по конверсии:</strong> 
          {{ bestVariant ? bestVariant.variant.name : '' }} ({{ bestVariant ? bestVariant.conversionRate : 0 }}%)
        </div>
      </CCardBody>
    </CCard>

    <!-- График конверсий по времени (если нужен) -->
    <CCard v-if="false">
      <CCardHeader>
        <strong>График конверсий</strong>
      </CCardHeader>
      <CCardBody>
        <div class="text-center text-muted py-4">
          График конверсий по времени будет добавлен в следующих версиях
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: 'AbTestStatistics',
  data() {
    return {
      statistics: null,
      loading: false,
      statisticsFields: [
        { key: 'variant', label: 'Вариант' },
        { key: 'weight', label: 'Вес' },
        { key: 'assignments', label: 'Участников' },
        { key: 'conversions', label: 'Конверсий' },
        { key: 'conversionRate', label: 'CR %' }
      ]
    }
  },
  computed: {
    totalAssignments() {
      if (!this.statistics || !this.statistics.statistics) return 0
      return this.statistics.statistics.reduce((sum, stat) => sum + stat.assignments, 0)
    },
    
    totalConversions() {
      if (!this.statistics || !this.statistics.statistics) return 0
      return this.statistics.statistics.reduce((sum, stat) => sum + stat.conversions, 0)
    },
    
    overallConversionRate() {
      if (this.totalAssignments === 0) return 0
      return ((this.totalConversions / this.totalAssignments) * 100).toFixed(2)
    },
    
    bestVariant() {
      if (!this.statistics || !this.statistics.statistics) return null
      return this.statistics.statistics.reduce((best, current) => 
        (current.conversionRate > (best ? best.conversionRate : 0)) ? current : best
      , null)
    }
  },
  async mounted() {
    await this.fetchStatistics()
  },
  methods: {
    async fetchStatistics() {
      this.loading = true
      try {
        const { data } = await this.$http.get(`/ab-tests/${this.$route.params.id}/statistics`)
        this.statistics = data
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки статистики')
        console.error(error)
        this.$router.push({
          path: '/ab-tests'
        })
      }
      this.loading = false
    },
    
    assignmentPercentage(assignments) {
      if (this.totalAssignments === 0) return 0
      return Math.round((assignments / this.totalAssignments) * 100)
    },
    
    conversionPercentage(conversions) {
      if (this.totalConversions === 0) return 0
      return Math.round((conversions / this.totalConversions) * 100)
    },
    
    conversionRateColor(rate) {
      if (rate >= 10) return 'text-success'
      if (rate >= 5) return 'text-warning'
      return 'text-danger'
    }
  }
}
</script> 